import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import './index.scss';
import PricingStore from 'stores/plugins/pricing';

export default class BaseballHallOfFameMembershipUpsell extends React.Component {
  static displayName = 'BaseballHallOfFameMembershipUpsell';
  static propTypes = {
    numOfAdults: PropTypes.number,
    total: PropTypes.number,
  };

  static defaultProps = {
    numOfAdults: 1,
    total: 25.3,
  };

  static membershipUrls = {
    individual: 'https://community.baseballhall.org/page.aspx?pid=1897',
    family: 'https://community.baseballhall.org/page.aspx?pid=1898',
    sustaining: ' https://community.baseballhall.org/page.aspx?pid=1899',
  };

  between(num, min, max) {
    return num >= min && num <= max;
  }

  formatSavings(num) {
    return `$${num.toFixed(2)}`;
  }

  defaultPitch() {
    return (
      <div>
        You may save money by buying a{' '}
        <a target="_new" href="http://baseballhall.org/support/become-a-member">
          membership plan
        </a>
        .
      </div>
    );
  }

  membershipLink(anchorText) {
    const membershipUrls = BaseballHallOfFameMembershipUpsell.membershipUrls;
    return (
      <a target="_new" href={membershipUrls[anchorText.toLowerCase()]}>
        {anchorText} Membership
      </a>
    );
  }

  getPitch() {
    const guests = this.props.numOfAdults;
    const total = this.props.total;
    let savings = 0;

    if (guests == 1 && this.between(total, 0, 30)) {
      savings = this.formatSavings(50 - total);
      return (
        <div>
          Buy an {this.membershipLink('Individual')} for just {savings} more.
        </div>
      );
    } else if (_.indexOf([1, 2], guests) >= 0) {
      if (this.between(total, 30.01, 80)) {
        savings = this.formatSavings(80 - total);
        return (
          <div>
            Buy a {this.membershipLink('Family')} for just {savings} more.
          </div>
        );
      } else if (this.between(total, 80.01, 500)) {
        savings = this.formatSavings(total - 80);
        return (
          <div>
            Save {savings} when you buy a {this.membershipLink('Family')}.
          </div>
        );
      }
    } else if (_.indexOf([3, 4], guests) >= 0) {
      if (this.between(total, 0, 125)) {
        savings = this.formatSavings(125 - total);
        return (
          <div>
            Buy a {this.membershipLink('Sustaining')} for just {savings} more.
          </div>
        );
      } else if (this.between(total, 125.01, 500)) {
        savings = this.formatSavings(total - 125);
        return (
          <div>
            Save {savings} when you buy a {this.membershipLink('Sustaining')}.
          </div>
        );
      }
    }
    return this.defaultPitch();
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.total != this.props.total;
  }

  render() {
    return (
      <div className="BaseballHallOfFameMembershipUpsell">
        <table>
          <tbody>
            <tr>
              <td className="leftCol">
                <i className="af-lamp" />
              </td>
              <td className="rightCol">{this.getPitch()}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}
